import { getItemLocalStorage } from "../functions/VLocalStorage";

export let _headers = () => {
   let headers = new Headers();
   headers.append('Content-Type', 'application/x-www-form-urlencoded');
   return headers;
}
 
export let _headers_with_token = () => {
   let headers = new Headers();
   let token = getItemLocalStorage('token');
   headers.append('Content-Type', 'application/x-www-form-urlencoded');
   headers.append('authorization', `Bearer ${ token }`);
   return headers;
}